export default {"src":"/_next/static/media/user.4783e261.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};